export default __webpack_public_path__ + "static/media/standinbgTableBgDec4.0d27fbfb.png";